import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, Row, Col, notification, Upload, Modal } from "antd";
import { MailOutlined, PhoneOutlined, MessageOutlined, UploadOutlined, ContactsOutlined } from "@ant-design/icons";
import emailjs from "emailjs-com";

const Contacts = () => {
  const { Title, Text } = Typography;
  const [form] = Form.useForm();
  const [fileBase64, setFileBase64] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  const userConnect = JSON.parse(localStorage.getItem("user_connect"));

  const getIpmFromCurrentUrl = () => {
    try {
      const hostname = window.location.hostname.toLowerCase();

      if (!hostname || hostname === "localhost") {
        return userConnect?.matipm || "Non connecté";
      }

      const hostParts = hostname.split(".").filter(Boolean);

      // Ex: portail.ipmafricmanagement.com -> ipmafricmanagement
      if (hostParts.length >= 3) {
        return hostParts[hostParts.length - 2];
      }

      // Ex: ipmafricmanagement.com -> ipmafricmanagement
      if (hostParts.length === 2) {
        return hostParts[0];
      }

      return userConnect?.matipm || "Non connecté";
    } catch (error) {
      return userConnect?.matipm || "Non connecté";
    }
  };

  const sendEmail = async (values) => {
    const ipmFromUrl = getIpmFromCurrentUrl();

    setIsSubmitting(true);
    try {
      const response = await emailjs.send(
        "service_la0h8w5", // Remplacez par votre Service ID
        "template_v8iujqb", // Remplacez par votre Template ID
        {
          // Version de la bibliothèque
          objet: values.objet, // Correspond à une variable dans votre modèle
          nom: values.nom,
          matricule: values.matricule,
          email: values.email,
          tel: values.telephone,
          message: values.message,
          fichier: fileBase64,
          ipm: ipmFromUrl,
        },
        "rtWXeD_UKWkV7vCuF"
      );

      setIsSuccessVisible(true);
      console.log("Email envoyé avec succès :", response.status, response.text);

      form.resetFields();
      setFileBase64(null);
      setFileList([]);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue lors de l'envoi du message.",
      });
      console.error("Erreur lors de l'envoi :", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (values) => {
    setPendingValues(values);
    setIsConfirmVisible(true);
  };

  const handleConfirmSend = async () => {
    if (!pendingValues) {
      setIsConfirmVisible(false);
      return;
    }

    setIsConfirmVisible(false);
    await sendEmail(pendingValues);
    setPendingValues(null);
  };

  const handleCancelSend = () => {
    setIsConfirmVisible(false);
    setPendingValues(null);
  };

  const beforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setFileBase64(e.target.result);
    };
    reader.readAsDataURL(file);
    setFileList([file]);
    return false; // Empêche Ant Design de faire un upload automatique
  };


  return (
    <div style={{
      padding: "20px",
      background: "linear-gradient(115deg, #eef2fc 0%, #e4f5ec 38%, #f9eedd 100%)",
      minHeight: "100vh",
      transition: "background 0.7s ease-in-out"
    }}>
      <h2 style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: 10 }}>
        <ContactsOutlined style={{ color: "#1f4ea1", fontSize: 28 }} />
        Contactez-nous
      </h2>
      <Text type="secondary">
        Pour toutes informations, vous pouvez appeler sur les numéros qui figurent sur les bons
        ou nous envoyer un message via ce formulaire.
      </Text>

      <Card style={{ marginTop: "20px" }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            nom: userConnect?.prenom + " " + userConnect?.nom || "",
            matricule: userConnect?.matricule || "",
            email: userConnect?.email || "",
            telephone: userConnect?.portable || "",
            ipm: getIpmFromCurrentUrl(),
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="objet"
                label="Objet"
                rules={[{ required: true, message: "Veuillez entrer un objet." }]}
              >
                <Input placeholder="Objet du message" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="nom"
                label="Nom*"
                rules={[{ required: true, message: "Veuillez entrer votre nom." }]}
              >
                <Input placeholder="Nom" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="matricule"
                label="Matricule*"
                rules={[{ required: true, message: "Veuillez entrer votre matricule." }]}
              >
                <Input placeholder="Matricule" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email*"
                rules={[
                  { required: true, message: "Veuillez entrer votre email." },
                  { type: "email", message: "Veuillez entrer un email valide." },
                ]}
              >
                <Input placeholder="Email" prefix={<MailOutlined />} />
              </Form.Item>
            </Col>


          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="telephone"
                label="Téléphone"
                rules={[{ required: true, message: "Veuillez entrer votre numéro de téléphone." }]}
              >
                <Input placeholder="Téléphone" prefix={<PhoneOutlined />} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Joindre un fichier">
                <Upload
                  beforeUpload={beforeUpload}
                  fileList={fileList}
                  maxCount={1}
                  showUploadList={{ showRemoveIcon: true }}
                  onRemove={() => {
                    setFileBase64(null);
                    setFileList([]);
                    return true;
                  }}
                >
                  <Button icon={<UploadOutlined />}>Sélectionner un fichier</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="message"
            label="Message*"
            rules={[{ required: true, message: "Veuillez entrer un message." }]}
          >
            <Input.TextArea rows={4} placeholder="Tapez votre message ici..." />
          </Form.Item>

          <Form.Item>
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
                icon={<MessageOutlined />}
                style={{
                  // backgroundColor: "#4a90e2",
                  // borderColor: "#4a90e2",
                  padding: "0 20px",
                }}
              >
                Envoyer votre message
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>

      <Modal
        title="Confirmer l'envoi"
        open={isConfirmVisible}
        onOk={handleConfirmSend}
        onCancel={handleCancelSend}
        okText="Envoyer"
        cancelText="Annuler"
        centered
        confirmLoading={isSubmitting}
      >
        Voulez-vous vraiment envoyer ce message ?
      </Modal>

      <Modal
        title="Mail bien envoyé"
        open={isSuccessVisible}
        onOk={() => setIsSuccessVisible(false)}
        onCancel={() => setIsSuccessVisible(false)}
        okText="OK"
        cancelButtonProps={{ style: { display: "none" } }}
        centered
      >
        Votre message a été envoyé avec succès !
      </Modal>
    </div>
  );
};

export default Contacts;
